module.exports = __webpack_public_path__ + "img/interaction-divine1.8f302079.png";